function makeFieldsDisabled(form) {
	var formFields = form.querySelectorAll('input, textarea, select');

	Array.prototype.forEach.call(formFields, function(formField) {
		formField.setAttribute('disabled', 'disabled');
	});
}

// get all data in form and return object
function getFormData(form) {
	var elements = form.elements;
	var honeypot;

	var fields = Object.keys(elements).filter(function(k) {
		if (elements[k].name === "honeypot") {
			honeypot = elements[k].value;
			return false;
		}
		return true;
	}).map(function(k) {
		if (elements[k].name !== undefined) {
			return elements[k].name;
		// special case for Edge's html collection
		} else if (elements[k].length > 0) {
			return elements[k].item(0).name;
		}
	}).filter(function(item, pos, self) {
		return self.indexOf(item) == pos && item;
	});

	var formData = {};
	fields.forEach(function(name) {
		var element = elements[name];

		// singular form elements just have one value
		formData[name] = element.value;

		// when our element has multiple items, get their values
		if (element.length) {
			var data = [];
			for (var i = 0; i < element.length; i++) {
				var item = element.item(i);
				if (item.checked || item.selected) {
					data.push(item.value);
				}
			}
			formData[name] = data.join(', ');
		}
	});

	return {
		data: formData,
		honeypot: honeypot,
	};
}

var handleErrorState = function(form) {
	var message = form.querySelector('.js-error-message');
	message.style.display = '';
	form.setAttribute('data-status', 'error');
};

var resetErrorMessages = function(form) {
	var message = form.querySelector('.js-error-message');
	message.style.display = 'none';
};

var handleSuccessState = function(form) {
	var message = form.querySelector('.js-thankyou-message');
	message.style.display = '';
};

var setButtonProgress = function(button) {
	button.disabled = true;
	button.classList.add('button--is-loading');
	button.setAttribute('data-label', button.innerText);
	button.innerText = 'Odesílám ...';
};

var resetButtonProgress = function(button) {
	button.disabled = false;
	button.classList.remove('button--is-loading');
	button.innerText = button.getAttribute('data-label');
};

function handleFormSubmit(event) {
	event.preventDefault();
	var form = event.target;
	var formData = getFormData(form);
	var data = formData.data;

	var submitButton = form.querySelector('.js-orderd-confirmation');
	setButtonProgress(submitButton);

	// If a honeypot field is filled, assume it was done so by a spam bot.
	if (formData.honeypot) {
		return false;
	}

	if (form.getAttribute('data-status') && form.getAttribute('data-status') == 'sent') {
		return false;
	}

	var request = new XMLHttpRequest();
	request.open('POST', 'https://hook.eu1.make.com/ium4kx1hlnnegownoh35c0r96o5gu4ih', true);
	request.timeout = 40000;
	request.setRequestHeader('Content-Type', 'application/json');

	request.onerror = function() {
		resetButtonProgress(submitButton);
		handleErrorState(form);
	}

	request.ontimeout = function() {
		resetButtonProgress(submitButton);
		handleErrorState(form);
	}

	request.onreadystatechange = function() {
		form.setAttribute('data-status', 'sent');

		// Request finished. Do processing here.
		if (this.response && this.readyState === XMLHttpRequest.DONE) {
			resetErrorMessages(form);
			resetButtonProgress(submitButton);

			if (this.status === 200) {
				if (this.response === 'Accepted') {
					handleSuccessState(form);

					dataLayer.push({'event': 'order-sent'});

					// we need to delay disabling of field to do that at the moment
					// once we will have visible overlay
					setTimeout(function() {
						makeFieldsDisabled(form);
						var formElements = form.querySelector(".js-form-elements");
						formElements.classList.add("order-layout__form--disabled"); // hide form
						form.reset();

						// add fragment to URL to be able to recognize new state, when order has been sent
						window.location.hash = 'objenavka-' + Date.now();
					}, 500);
				} else {
					handleErrorState(form);
				}
			} else {
				handleErrorState(form);
			}
		}
	}

	request.send(JSON.stringify(data));
}

function loaded() {
	// bind to the submit event of our form
	var forms = document.querySelectorAll("form.js-form");
	for (var i = 0; i < forms.length; i++) {
		forms[i].addEventListener("submit", handleFormSubmit, false);
	}
};

document.addEventListener("DOMContentLoaded", loaded, false);
